import { render, staticRenderFns } from "./productApproval.vue?vue&type=template&id=050299ef&scoped=true"
import script from "./productApproval.vue?vue&type=script&lang=js"
export * from "./productApproval.vue?vue&type=script&lang=js"
import style0 from "./productApproval.vue?vue&type=style&index=0&id=050299ef&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050299ef",
  null
  
)

export default component.exports